/** Challenge accept/decline/settle rules — mirror PickEm.Core/Rules/ChallengeRules.cs */

export const DECISION_PENDING = "pending";
export const DECISION_ACCEPTED = "accepted";
export const DECISION_DECLINED = "declined";
export const OUTCOME_NONE = "";
export const OUTCOME_COMPLETED = "completed";
export const OUTCOME_FAILED = "failed";

export function isValidFaab(faab) {
  return faab >= 10 && faab <= 50;
}

export function canOfferDecision(
  challenge,
  signedInTeamId,
  weekPassedDue,
  justSubmittedWeekly
) {
  if (!challenge || !signedInTeamId) return false;
  if (weekPassedDue || !justSubmittedWeekly) return false;
  if (String(challenge.Tid) !== String(signedInTeamId)) return false;
  return String(challenge.Decision || "").toLowerCase() === DECISION_PENDING;
}

/** Recipient can reopen a pending offer before lock without a fresh submit. */
export function shouldReopenOnHome(challenge, signedInTeamId, weekPassedDue) {
  if (!challenge || !signedInTeamId) return false;
  if (weekPassedDue) return false;
  if (String(challenge.Tid) !== String(signedInTeamId)) return false;
  return String(challenge.Decision || "").toLowerCase() === DECISION_PENDING;
}

export function applyDecision(challenge, decision, atIso) {
  if (String(challenge.Decision || "").toLowerCase() !== DECISION_PENDING) {
    throw new Error("Challenge already decided.");
  }
  const normalized = String(decision || "").trim().toLowerCase();
  if (normalized !== DECISION_ACCEPTED && normalized !== DECISION_DECLINED) {
    throw new RangeError("Decision must be accepted or declined.");
  }
  return { ...challenge, Decision: normalized, DecidedAt: atIso };
}

export function isPubliclyVisible(challenge, weekPassedDue) {
  return Boolean(challenge && weekPassedDue);
}

export function publicDecisionLabel(decision) {
  const d = String(decision || "").toLowerCase();
  if (d === DECISION_ACCEPTED) return "Accepted";
  if (d === DECISION_DECLINED) return "Sat this one out";
  return "Not accepted";
}

export function canSettle(challenge, isAdmin, currentWeek) {
  if (!isAdmin || !challenge) return false;
  if (String(challenge.Decision || "").toLowerCase() !== DECISION_ACCEPTED) {
    return false;
  }
  if (challenge.Outcome) return false;
  return challenge.Week < currentWeek;
}

export function applySettle(challenge, outcome, atIso) {
  if (String(challenge.Decision || "").toLowerCase() !== DECISION_ACCEPTED) {
    throw new Error("Only accepted challenges can be settled.");
  }
  if (challenge.Outcome) {
    throw new Error("Challenge already settled.");
  }
  const normalized = String(outcome || "").trim().toLowerCase();
  if (normalized !== OUTCOME_COMPLETED && normalized !== OUTCOME_FAILED) {
    throw new RangeError("Outcome must be completed or failed.");
  }
  return { ...challenge, Outcome: normalized, SettledAt: atIso };
}

export function formatHistoryLine(challenge) {
  const decision = publicDecisionLabel(challenge.Decision);
  const outcome = challenge.Outcome ? ` · ${challenge.Outcome}` : "";
  return `Week ${challenge.Week}: ${challenge.RecipientName} — ${challenge.Text} ($${challenge.Faab} FAAB) · ${decision}${outcome}`;
}
